import { createContext } from 'react';

export const OrgTreeContext = createContext({
  dispatch: () => {},
  uniqueContextId: Symbol('org-management'),
  find: () => undefined,
  activeDropHighlightKey: null,
  setActiveDropHighlightKey: () => {},
  setIsOrgTreeDragActive: () => {},
});
